import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/', '/mobileHome','/login', '/auth-redirect', '/loginticket', '/article'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()
  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    // if (sessionStorage.getItem('saveTitle')) {
    //   document.title = sessionStorage.getItem('saveTitle')
    // } else {
    //   getPageTitle()
    // }
    if (to.path === '/loginticket') {
      // if is logged in, redirect to the home page
      next({ path: '/compments' })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const { channelId } = await store.dispatch('user/indexInfo')
          const { roles } = await store.dispatch('user/getInfo')
          
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch(
            'permission/generateRoutes',
            roles
          )
          // dynamically add accessible routes
          router.addRoutes(accessRoutes)
          // const lastRou = [{ path: '*', redirect: '/404' }]
          // router.addRoutes(lastRou)

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
          // next({ path: '/compments' })
          next()
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error.message || 'Has Error')
          // next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    const { channelId } = await store.dispatch('user/indexInfo')
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      let Mobile  = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if(Mobile && to.path =='/' ){
       next({path: '/mobileHome'})
      }

      if(to.path =='/mobileHome' && !Mobile){
        next({path: '/'})
      }

      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
